var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye1Gray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 13.6083C8.00839 13.6083 6.39172 11.9916 6.39172 9.99994C6.39172 8.00827 8.00839 6.3916 10.0001 6.3916C11.9917 6.3916 13.6084 8.00827 13.6084 9.99994C13.6084 11.9916 11.9917 13.6083 10.0001 13.6083ZM10.0001 7.6416C8.70006 7.6416 7.64172 8.69993 7.64172 9.99994C7.64172 11.2999 8.70006 12.3583 10.0001 12.3583C11.3001 12.3583 12.3584 11.2999 12.3584 9.99994C12.3584 8.69993 11.3001 7.6416 10.0001 7.6416Z",
    fill: "#657892"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9999 17.5167C6.86657 17.5167 3.90824 15.6834 1.8749 12.5001C0.991569 11.1251 0.991569 8.8834 1.8749 7.50007C3.91657 4.31673 6.8749 2.4834 9.9999 2.4834C13.1249 2.4834 16.0832 4.31673 18.1166 7.50007C18.9999 8.87507 18.9999 11.1167 18.1166 12.5001C16.0832 15.6834 13.1249 17.5167 9.9999 17.5167ZM9.9999 3.7334C7.30824 3.7334 4.73324 5.35007 2.93324 8.17507C2.30824 9.15007 2.30824 10.8501 2.93324 11.8251C4.73324 14.6501 7.30824 16.2667 9.9999 16.2667C12.6916 16.2667 15.2666 14.6501 17.0666 11.8251C17.6916 10.8501 17.6916 9.15007 17.0666 8.17507C15.2666 5.35007 12.6916 3.7334 9.9999 3.7334Z",
    fill: "#657892"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye1Gray);
export default __webpack_public_path__ + "static/media/eye-1-gray.60be49081a0b7e38780f5769f3bd0971.svg";
export { ForwardRef as ReactComponent };